import { Controller } from "@hotwired/stimulus"

// Dropdown for the new (Tailwind) UI — replaces Bootstrap's data-bs-toggle="dropdown".
// Usage:
//   <div data-controller="tw-dropdown" class="relative">
//     <button data-action="tw-dropdown#toggle">…</button>
//     <div data-tw-dropdown-target="menu" class="hidden …">…</div>
//   </div>
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.onDocClick = this.onDocClick.bind(this)
    this.onKey = this.onKey.bind(this)
    document.addEventListener("click", this.onDocClick)
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocClick)
    document.removeEventListener("keydown", this.onKey)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    if (this.hasMenuTarget) this.menuTarget.classList.add("hidden")
  }

  onDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKey(event) {
    if (event.key === "Escape") this.close()
  }
}
